import { Dispatch, Middleware } from 'redux'

import { RootState } from 'store/rootReducer'

import { apiSlice } from '@/shared/api/apiSlice'

import { selectBasketGiftIds } from '../../lib/basket-gifts'
import { giftsLsService } from '../../utils/gifts-ls-service'
import { clearBasketSuccess } from '../cart-slice'
import { addedProductToCartEvent, removedGiftForProductEvent, selectedGiftForProductEvent } from '../events'

// eslint-disable-next-line @typescript-eslint/ban-types
export const cartMiddleware: Middleware<{}, RootState, Dispatch> = store => next => action => {
	const previousGiftIds = selectBasketGiftIds(store.getState()).join(',')
	const result = next(action)

	const shouldSaveGiftsAction =
		action.type === addedProductToCartEvent.type ||
		action.type === selectedGiftForProductEvent.type ||
		action.type === removedGiftForProductEvent.type ||
		action.type === clearBasketSuccess.type

	if (shouldSaveGiftsAction) giftsLsService.set(store.getState().cart.gifts)

	// Только смена применённых подарков требует дополнительного пересчёта цен.
	if (previousGiftIds !== selectBasketGiftIds(store.getState()).join(',')) {
		store.dispatch(apiSlice.util.invalidateTags(['Cart']))
	}

	return result
}
